import { render, staticRenderFns } from "./WakeupApp.vue?vue&type=template&id=b5793d90&scoped=true"
import script from "./WakeupApp.vue?vue&type=script&lang=js"
export * from "./WakeupApp.vue?vue&type=script&lang=js"
import style0 from "./WakeupApp.vue?vue&type=style&index=0&id=b5793d90&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5793d90",
  null
  
)

export default component.exports